module.exports = __webpack_public_path__ + "img/web.3e97efd0.jpg";